<template>
	<div class="step-tags">
		<div
			class="step-group"
			v-for="group in displayedTagGroups"
			:key="group.id"
			:data-test="`step-tag-group-${group.name}`"
		>
			<div class="caption">{{ group.name }}</div>

			<div class="step-group-tags">
				<div
					class="step-tag caption-2"
					:class="{active: isTagActive(tag)}"
					v-for="tag in group.tags"
					:key="tag.id"
					@click="selectTag(tag)"
					:data-test="`step-tag-${tag.name}`"
				>
					{{ tag.name }}
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'StepTags',
	props: {
		workflow: {
			type: Object,
		},
	},
	methods: {
		isTagActive(tag) {
			let tags = this.$store.getters['tags/activeStepTags'];
			if (tags[this.workflow.name]) {
				return Object.values(tags[this.workflow.name]).some((tagGroup) => tagGroup.has(tag.id));
			} else return false;
		},
		selectTag(tag) {
			this.isTagActive(tag)
				? this.$store.dispatch('tags/unsetActiveStepTag', {step: this.workflow.name, tag: tag})
				: this.$store.dispatch('tags/setActiveStepTag', {step: this.workflow.name, tag: tag});
		},
	},
	computed: {
		tags() {
			let products = this.$store.getters['workflow/stepProducts'](this.workflow.name);
			if (!products) {
				return [];
			}
			let productsTagsIds = products
				.map((p) => this.$store.getters['tags/productTagAssignments'](p).map((tag) => tag.id))
				.flat();
			let uniqueProductsTagsIds = new Set(productsTagsIds);
			return Array.from(uniqueProductsTagsIds).map((id) => this.$store.getters['tags/tags'][id]);
		},
		tagGroups() {
			return this.$store.getters['tags/uniqueAssignedTagGroups']('STEP');
		},
		displayedTagGroups() {
			if (this.workflow.customContent) {
				return [];
			}
			return this.tagGroups.reduce((acc, group) => {
				//filter groups with less than 2 tags in current workflow, sorted by order in group.tags
				let existingTags = group.tags.reduce((tags, tagId) => {
					return [...tags, ...this.tags.filter((tag) => tag.id === tagId)];
				}, []);
				return existingTags.length > 1 ? [...acc, {...group, tags: existingTags}] : acc;
			}, []);
		},
	},
};
</script>
<style scoped lang="scss">
.step-tags {
	padding-left: 20px;
	display: flex;
	flex-wrap: wrap;
	gap: 0 20px;
	.step-group {
		margin: 16px 0;
		.step-group-tags {
			@include flexRow;
			flex-wrap: wrap;
			.step-tag {
				white-space: nowrap;
				border: 1px solid;
				border-radius: 10px;
				border-color: $color-text-grey;
				padding: 4px 8px;
				margin: 4px 8px 4px 0;
				cursor: pointer;
				&.active {
					border-color: $color-blue;
					border-width: 2px;
					background: $color-super-light-blue;
					color: $color-blue;
				}
			}
		}
	}
}
</style>